import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vExpertizeSubCategoryRecordBase {

//#region expertizeId Prop
        @gridColumn({visible: false, columnIndex:0, allowSorting: true, headerKey: 'expertizeId', keyColumn: true})
        expertizeId : number;
//#endregion expertizeId Prop


//#region expertizeSubCategoryName Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'expertizeSubCategoryName', keyColumn: false})
        expertizeSubCategoryName : string;
//#endregion expertizeSubCategoryName Prop


//#region expertizeSubCategoryDescription Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'expertizeSubCategoryDescription', keyColumn: false})
        expertizeSubCategoryDescription : string;
//#endregion expertizeSubCategoryDescription Prop


//#region expertizeSubCategoryId Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'expertizeSubCategoryId', keyColumn: false})
        expertizeSubCategoryId : number;
//#endregion expertizeSubCategoryId Prop


//#region statusId Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'statusId', keyColumn: false})
        statusId : number;
//#endregion statusId Prop


//#region createdBy Prop
        @gridColumn({visible: true, columnIndex:5, allowSorting: true, headerKey: 'createdBy', keyColumn: false})
        createdBy : number;
//#endregion createdBy Prop


//#region createdOn Prop
        @gridColumn({visible: true, columnIndex:6, allowSorting: true, headerKey: 'createdOn', keyColumn: false})
        createdOn : any;
//#endregion createdOn Prop

}